import { Injectable, inject } from '@angular/core';
import { Auth, signInWithCustomToken, user as getUser } from '@angular/fire/auth';
import { firstValueFrom } from 'rxjs';
import { E2E_MODE } from './e2e-mode.token';

/** E2E-build-only sign-in from a `?token=` custom token minted by the Auth emulator. */
@Injectable({ providedIn: 'root' })
export class TokenProviderService {
  private afAuth = inject(Auth);
  private e2e = inject(E2E_MODE);
  private consumed = false;

  public async signInWithToken(search = window.location.search): Promise<void> {
    if (!this.e2e || this.consumed) {
      return;
    }

    const token = new URLSearchParams(search).get('token');
    if (!token) {
      return;
    }
    // Latch only once a token is seen, or a token-less first route disables sign-in for good.
    this.consumed = true;

    if (await firstValueFrom(getUser(this.afAuth))) {
      return;
    }
    await signInWithCustomToken(this.afAuth, token);
  }
}
